module.exports = __webpack_public_path__ + "static/media/pino_bergen.c998e0ff.jpg";